import React from "react";
import { NavLink } from "react-router-dom";
import CategoryHelper from "../CategoryHelper";
import { DateTime } from "luxon";
import styles from "./EventsTile.module.css";

const EventsTile = (props) => {
  // Format date as "JANUARY 1, 2021"
  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const dt = DateTime.fromISO(dateString, { zone: "utc" });
      return dt.toFormat("MMMM d, yyyy").toUpperCase();
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  };

  // Format address
  const formatAddress = () => {
    const parts = [];
    if (props.Event.BP_Address) parts.push(props.Event.BP_Address);
    if (props.Event.BP_Address2) parts.push(props.Event.BP_Address2);
    return parts.join(", ");
  };

  // Format location
  const formatLocation = () => {
    const parts = [];
    if (props.Event.BP_City) parts.push(props.Event.BP_City);
    if (props.Event.BP_State) parts.push(props.Event.BP_State);
    if (props.Event.BP_Country) parts.push(props.Event.BP_Country);
    return parts.join(", ");
  };

  return (
    <NavLink 
      to={"/events/details/" + props.Event.EventsID} 
      className={styles.eventWrapperLink}
    >
      <div className={styles.eventWrapper}>
        <div className="row align-items-center">
          <div className="col-md-9">
            <div className="row">
              <div className="col-md-12">
                <div className={styles.eventDateRow}>
                  <span className={styles.eventDate}>
                    {formatDate(props.Event.BP_StartDate)}
                  </span>
                  {props.Event.BP_DatesFlexible && (
                    <span className={styles.flexibleFlag}>
                      FLEXIBLE/OPEN DATES
                    </span>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className={styles.eventName}>
                  {props.Event.BP_Title}
                </div>
              </div>
              {formatAddress() && (
                <div className="col-md-12">
                  <div className={styles.eventAddress}>
                    {formatAddress()}
                  </div>
                </div>
              )}
              <div className="col-md-12">
                <div className={styles.eventLocation}>
                  {formatLocation()}
                </div>
              </div>
              <div className="col-md-12">
                <div className={styles.eventCategories}>
                  <CategoryHelper
                    Event={props?.Event}
                    Categories={props?.Categories}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 text-md-right">
            <div className={props.Event.BP_Reserved ? styles.eventButtonReserved : styles.eventButton}>
              {props.Event.BP_Reserved ? 'Reserved' : 'Learn More'}
            </div>
          </div>
        </div>
      </div>
    </NavLink>
  );
};

export default EventsTile;
